import scene from "./recycling-scene.png";
import styles from "./recycling-scene.module.css";

/**
 * The recycling loop — truck, plant, sorting line, bins — at the foot of the page for someone
 * who has no project yet. The white around it was made transparent so it sits on any surface.
 */
export function RecyclingScene({ className }: { className?: string }) {
  return <img className={`${styles.scene} ${className ?? ""}`} src={scene} alt="" aria-hidden draggable={false} />;
}
